import { isTyomarkkinatoriJobSource } from '../job-source/is-tyomarkkinatori-job-source';
import { coerceTypesenseBoolField } from '../typesense/coerce-typesense-bool-field';

/** Official Työmarkkinatori mark used on SRP cards (matches getCompanyLogoDefaultSrc). */
export const TYOMARKKINATORI_LOGO_PATH = '/tyomarkkinatori.svg';

/**
 * Resolve Työmarkkinatori the same way as Algolia/maintainer: flag or tyomarkkinatori.fi URL.
 */
export function resolveSearchHitIsTyomarkkinatori(hit: Record<string, unknown>): boolean {
  const url = typeof hit.url === 'string' ? hit.url : undefined;
  const flag = coerceTypesenseBoolField(hit.isTyomarkkinatori) ?? hit.isTyomarkkinatori;
  return isTyomarkkinatoriJobSource(url, flag);
}
